import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparison } from '../data/content';
export function Comparison() {
  return <section aria-labelledby="comparison-heading" className="bg-cloud" data-id="element-71" data-mp="1g8ud0y5t1pn7">
      <div className="mx-auto max-w-page px-4 py-12 sm:px-5 lg:py-24" data-id="element-72" data-mp="1l6cr12yoiv22">
        <h2 id="comparison-heading" className="font-display text-2xl font-extrabold leading-[1.08] tracking-[-0.03em] text-navy sm:text-4xl" data-id="element-73" data-mp="1pxuh2vz5zb89">
          Before vs. after
        </h2>

        {/* Mobile: stacked pairs */}
        <ul className="mt-8 space-y-4 sm:hidden" data-id="element-74" data-mp="1zuqspakd0dh1">
          {comparison.map(row => <li key={row.without} className="overflow-hidden rounded-lg border border-slate-200" data-id="element-75" data-mp="23z6uazmxwyqg">
              <div className="flex items-start gap-3 bg-white px-4 py-3.5" data-id="element-76" data-mp="28vozg0m6mz3b">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" strokeWidth={3} data-id="element-77" data-mp="9kntr2lyl5b2" />
                <span className="text-sm text-slate-500" data-id="element-78" data-mp="1m0h00lcnse4v">{row.without}</span>
              </div>
              <div className="flex items-start gap-3 border-t-2 border-gold bg-white px-4 py-3.5" data-id="element-79" data-mp="1ha8zgt4ynxtp">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-deep" aria-hidden="true" strokeWidth={3} data-id="element-80" data-mp="1d85kvvmzwd47" />
                <span className="font-display text-sm font-bold text-navy" data-id="element-81" data-mp="187hmgowfstzy">{row.with}</span>
              </div>
            </li>)}
        </ul>

        {/* Tablet and up: full table */}
        <div className="mt-10 hidden sm:block" data-id="element-82" data-mp="20w5c0wo7y5jb">
          <table className="w-full border-collapse text-left" data-id="element-83" data-mp="1vxu26lxxbv13">
            <thead data-id="element-84" data-mp="1qzsflr1ahdkv">
              <tr data-id="element-85" data-mp="1r0lg4a9nn6uk">
                <th scope="col" className="w-1/2 border-b border-slate-300 pb-4 pr-6 font-display text-xs font-extrabold uppercase tracking-[0.18em] text-slate-500" data-id="element-86" data-mp="1qz0ksifinjvn">
                  Without the Arsenal
                </th>
                <th scope="col" className="w-1/2 border-b-2 border-gold pb-4 pl-6 font-display text-xs font-extrabold uppercase tracking-[0.18em] text-gold-deep" data-id="element-87" data-mp="h1kdi5p55y6m">
                  With the Arsenal
                </th>
              </tr>
            </thead>
            <tbody data-id="element-88" data-mp="cz5unllh2yfc">
              {comparison.map(row => <tr key={row.without} data-id="element-89" data-mp="3ugp3d8hifcv8">
                  <td className="border-b border-slate-200 py-5 pr-6 align-top" data-id="element-90" data-mp="3ufnosu1ac88r">
                    <span className="flex items-start gap-3 text-[15px] text-slate-500" data-id="element-91" data-mp="32axp74ul636">
                      <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" strokeWidth={3} data-id="element-92" data-mp="3lgk79uhro0wd" />
                      {row.without}
                    </span>
                  </td>
                  <td className="border-b border-slate-200 bg-white py-5 pl-6 pr-5 align-top" data-id="element-93" data-mp="3ggo1pqtf81ep">
                    <span className="flex items-start gap-3 font-display text-[15px] font-bold text-navy" data-id="element-94" data-mp="2wuvwe2bd7dza">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-deep" aria-hidden="true" strokeWidth={3} data-id="element-95" data-mp="2rwknpuwt39in" />
                      {row.with}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}